import { useFeatureFlagValue } from "../../../../config/FeatureFlagManager/hooks.ts";
import { getAppName } from "./getAppName.ts";

export const useAppName = () => {
  const enableClaMode = useFeatureFlagValue("enableClaMode");
  const enableProductTestingBusinessDomain = useFeatureFlagValue(
    "enableProductTestingBusinessDomain",
  );
  return getAppName(enableClaMode, enableProductTestingBusinessDomain);
};
